<template>
	<div style="width:100%;heigh:100%;" id="alarm-mgt">
		<div class="table_searchbar">
			<el-row :gutter="W?20:0">
				<el-col :span="span">
					<div class="" @keydown.enter="btnSearch()">
						<span class="title">告警名：</span>
						<el-input class='target' style="width:180px" size="small" v-model="searchForm.name" maxlength="16" placeholder="告警名称"></el-input>
					</div>
				</el-col>
				<el-col :span="span">
					<div class="" @keydown.enter="btnSearch()">
						<span class="title">告警等级：</span>
						<el-select style="max-width:180px" size="small" v-model="searchForm.level" maxlength="16" placeholder="请选择">
							<el-option label="高" value=1></el-option>
							<el-option label="中" value=2></el-option>
							<el-option label="低" value=3></el-option>
						</el-select>
					</div>
				</el-col>
				<el-col :span="W?span:6">
					<div class="" @keydown.enter="btnSearch()">
						<span class="title">告警状态：</span>
						<el-select style="max-width:180px" size="small" v-model="searchForm.status" maxlength="16" placeholder="请选择">
							<el-option label="待执行" value=0></el-option>
							<el-option label="执行中" value=1></el-option>
							<el-option label="已执行" value=2></el-option>
						</el-select>
					</div>
				</el-col>
				<el-col :span="W?(24-3*span):4">
					<div style="text-align:right">
						<el-button size='mini' type="primary" icon="el-icon-search" @click="btnSearch()">查询</el-button>
						<el-button size='mini' icon="el-icon-refresh"  @click='clearSearch'>重置</el-button>
					</div>
				</el-col>
			</el-row>
		</div>

		<div class="table_common_operbar">
			<el-row>
				<el-button icon="el-icon-plus" type="primary" size="small" @click="addDialogShow()" v-if="permission.btn_alarmRule_add">新增</el-button>
			</el-row>
		</div>

		<!-- 新增窗口开始 -->
		<el-dialog title="新增告警规则" :visible.sync="addDialogVisible" width="670px" center :close-on-click-modal="false" @open="$refs['addForm']&&$refs['addForm'].clearValidate()">
			<el-form ref="addForm" :model="addForm" inline label-width="90px" label-position="right">
				<el-row>
					<el-col :span="12">
						<el-form-item   label-width="100px" label="告警名" prop="name" :rules="addForm.alarmNameRule">
							<el-input ref="focusinput" v-model="addForm.name" class="form__input" maxlength="20"/>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label-width="100px" label="告警推送方式">
							<el-select v-model="addForm.alarmSendType" class="form__input">
								<el-option v-for="sendType in sendTypeList" :key="sendType.id" :label="sendType.name" :value="sendType.id" />
							</el-select>
						</el-form-item>
					</el-col> 
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label-width="100px" label="告警等级">
							<el-select v-model="addForm.alarmLevel" class="form__input">
								<el-option label="低" :value="3"/>
								<el-option label="中" :value="2"/>
								<el-option label="高" :value="1"/>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label-width="100px" label="告警类型">
							<el-select v-model="addForm.ruleType" class="form__input">
								<el-option label="业务告警" :value="3"/>
								<el-option label="设备故障" :value="2"/>
								<el-option label="通信故障" :value="1"/>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row> 
				<el-row>
					<el-col :span="24">
						<el-form-item label-width="100px" label="备注">
							<el-input class="form__textarea" v-model="addForm.remarks" type="textarea" :rows="2" :maxlength="200" placeholder="最多不超过200字符"/>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span='24'>
						<span style="width: 78px;text-align: right;display: inline-block;margin-right: 20px;">规则明细</span>
						<el-button type="primary" size="mini" @click="addRuleLine('addForm')">添加</el-button>
					</el-col>
				</el-row>
				
				<div class="dialog__list">
					<div v-for="(rule,index) in addForm.rules" :key="index" class="ruleSpecfic">
						<el-form-item v-show="index!=0" label="连接符" label-width="80px">
							<el-select v-model="rule.correlation" class="form__input_small input-min-width">
								<el-option value="and"/>
								<el-option value="or"/>
							</el-select>
						</el-form-item>
						<br>
						<el-form-item label="规则键" label-width="80px" :prop="'rules.'+index+'.ruleKey'" :rules="[{ required: true, message: '请输入规则键', trigger: 'blur' }]" >
							<el-input v-model="rule.ruleKey" class="form__input_small input-min-width"/>
						</el-form-item>
						<el-form-item label="规则运算符">
							<el-select v-model="rule.operator" class="form__input_small input-min-width">
								<el-option value=">="/>
								<el-option value=">"/>
								<el-option value="="/>
								<el-option value="<"/>
								<el-option value="<="/>
								<el-option value="is"/>
								<el-option value="isnot"/>
							</el-select>
						</el-form-item>
						<el-form-item label-width="70px" label="规则值" :prop="'rules.'+index+'.ruleValue'" :rules="[{ required: true, message: '请输入规则值', trigger: 'blur' }]" >
							<el-input v-model="rule.ruleValue" class="form__input_small"/>
						</el-form-item>
						<!-- <el-button v-if="index!=0" type="text" @click="delRuleLine(index,'addForm')">删除</el-button> -->
						<div class="delete"   type="primary"  @click="delRuleLine(index,'addForm')"></div>
					</div>
				</div>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="addAlarmRule()">确 定</el-button>
				<el-button @click="addDialogVisible = false">取 消</el-button>
			</span>
		</el-dialog>

		<!-- 编辑窗口开始 -->
		<el-dialog title="编辑告警规则" :visible.sync="editDialogVisible" width="670px" center :close-on-click-modal="false" @open="$refs['editForm']&&$refs['editForm'].clearValidate()">
			<el-form :model="editForm" :rules="rules" inline ref="editForm" class="addForm">
				<el-row>
					<el-col :span="12">
						<el-form-item label-width="100px" label="告警名" prop="name" :rules="editForm.alarmNameRule">
							<el-input v-model="editForm.name" class="form__input" maxlength="20"/>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label-width="100px" label="告警推送方式">
							<el-select v-model="editForm.alarmSendType" class="form__input">
								<el-option v-for="sendType in sendTypeList" :key="sendType.id" :label="sendType.name" :value="sendType.id"/>
							</el-select>
						</el-form-item>
					</el-col> 
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label-width="100px" label="告警等级">
							<el-select v-model="editForm.alarmLevel" class="form__input">
							<el-option label="低" :value="3"/>
							<el-option label="中" :value="2"/>
							<el-option label="高" :value="1"/>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label-width="100px" label="告警类型">
							<el-select v-model="editForm.ruleType" class="form__input">
							<el-option label="业务告警" :value="3"/>
							<el-option label="设备故障" :value="2"/>
							<el-option label="通信故障" :value="1"/>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row> 
				<el-row>
					<el-col :span="24">
						<el-form-item label-width="100px" label="备注">
							<el-input class="form__textarea" v-model="editForm.remarks" type="textarea" :rows="2" :maxlength="200" placeholder="最多不超过200字符" />
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span='24'>
						<span style="width: 78px;text-align: right;display: inline-block;margin-right: 20px;">规则明细</span>
						<el-button type="primary" size="mini" @click="addRuleLine('editForm')">添加</el-button>
					</el-col>
				</el-row>
				<div class="dialog__list">
					<!-- <el-scrollbar style="height:100%"> -->
					<div v-for="(rule,index) in editForm.rules" :key="index" class="ruleSpecfic">
						<el-form-item v-show="index!=0" label="连接符" label-width="80px">
							<el-select v-model="rule.correlation" class="form__input_small input-min-width">
								<el-option value="and"/>
								<el-option value="or"/>
							</el-select>
						</el-form-item>
						<br>
						<el-form-item label="规则键" label-width="80px" :prop="'rules.'+index+'.ruleKey'" :rules="[{ required: true, message: '请输入规则键', trigger: 'blur' }]">
							<el-input v-model="rule.ruleKey" class="form__input_small"/>
						</el-form-item>
						<el-form-item label="规则运算符">
							<el-select v-model="rule.operator" class="form__input_small input-min-width">
								<el-option value=">="/>
								<el-option value=">"/>
								<el-option value="="/>
								<el-option value="<"/>
								<el-option value="<="/>
								<el-option value="is"/>
								<el-option value="isnot"/>
							</el-select>
						</el-form-item>
						<el-form-item label-width="70px" label="规则值" :prop="'rules.'+index+'.ruleValue'" :rules="[{ required: true, message: '请输入规则值', trigger: 'blur' }]">
							<el-input v-model="rule.ruleValue" class="form__input_small"/>
						</el-form-item>
						<!-- <el-button v-if="index!=0" type="text" @click="delRuleLine(index,'editForm')">删除</el-button> -->
						<div class="delete"   type="primary"  @click="delRuleLine(index,'editForm')"></div>
					</div>
				</div>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="editAlarmRule()">确 定</el-button>
				<el-button @click="editDialogVisible = false">取 消</el-button>
			</span>
		</el-dialog>

		<!-- 查看窗口开始 -->
		<el-dialog class="view_dialog" title="查看告警规则"  width="800px" :visible.sync="viewDialogVisible"  center>
			<el-form>
				<el-row>
					<el-col :span="12">
						<span style="text-align: right;display: inline-block;width:100px">告警名：</span>
						<span>{{viewForm.name}}</span>
					</el-col>
					<el-col :span="12">
						<span style="text-align: right;display: inline-block;width:100px">告警推送方式：</span>
						<span>{{viewForm.alarmSendTypeId}}</span>
					</el-col> 
				</el-row>
				<el-row>
					<el-col :span="12">
						<span style="text-align: right;display: inline-block;width:100px">告警类型：</span>
						<span>{{viewForm.ruleType}}</span>
					</el-col>
					<el-col :span="12">
						<span style="text-align: right;display: inline-block;width:100px">告警等级：</span>
						<span>{{viewForm.alarmLevel}}</span>
					</el-col>
				</el-row> 
				<el-row>
					<el-col :span="24">
						<span style="text-align: right;display: inline-block;width:100px">备注：</span>
						<span>{{viewForm.remarks}}</span>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span='24'>
						<span style="width: 78px;text-align: right;display: inline-block;margin-right: 20px;">规则明细</span>
					</el-col>
				</el-row>
				<div class="dialog__list">
					<div v-for="(rule,index) in viewForm.rules" :key="index" class="ruleSpecfic">
						<el-row v-show="index!=0">
							<el-col :span='8' >
								<el-form-item  label="连接符" label-width="80px">
									<el-select v-model="rule.correlation" class="form__input_small input-min-width" :disabled="true">
										<el-option value="and"/>
										<el-option value="or"/>
									</el-select>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span='8'>
								<el-form-item label="规则键" label-width="80px">
									<el-input v-model="rule.ruleKey" :disabled="true" class="form__input_small"/>
								</el-form-item>
							</el-col>
							<el-col :span='8'>
								<el-form-item label="规则运算符">
									<el-select v-model="rule.operator" class="form__input_small input-min-width" :disabled="true">
										<el-option value=">="/>
										<el-option value=">"/>
										<el-option value="="/>
										<el-option value="<"/>
										<el-option value="<="/>
										<el-option value="is"/>
										<el-option value="isnot"/>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span='8'>
								<el-form-item label-width="70px" label="规则值">
									<el-input v-model="rule.ruleValue" class="form__input_small" :disabled="true"/>
								</el-form-item>
							</el-col>
						</el-row>
					</div>
				</div>
			</el-form>
			<span slot="footer" class="dialog-footer" style="margin-top:50px; margin-bottom:30px;">
				<el-button type="primary" @click="viewDialogVisible = false">确 定</el-button>
			</span>
		</el-dialog>

		<el-table :data="tableData" stripe style="width: 100%" class="y_Public_table">
			<el-table-column prop="name" label="告警名" >
				<template slot-scope="scope">
					<div class="y_clamp" ref="Tmover" @mouseover="TmouseOver(scope.$index)" @mouseleave="Tonmouseout()"><span>{{scope.row.name}}</span></div>
					<div class="y_pos_able" v-if="scope.$index == TmouserShow">
						<span>{{scope.row.name}}</span>
						<div class="y_triangle"></div>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="ruleType" label="告警类型" :formatter="row=> {return ruleType.get(row.ruleType)}"></el-table-column>
			<el-table-column prop="level" label="告警等级"  :formatter="row=> {return level.get(row.level)}"></el-table-column>
			<el-table-column prop="status" label="告警状态"  :formatter="row=> {return status.get(row.status)}"></el-table-column>
			<el-table-column prop="remarks" label="备注"  ></el-table-column>
			<el-table-column prop="gmtCreate" :formatter='parseDate' label="创建时间"  ></el-table-column>
			<el-table-column label="操作" fixed="right" width='190' >
				<template slot-scope="scope">
					<el-button @click="viewDtu(scope.row)" type="text" size="small" v-if="permission.btn_dtu_get">查看</el-button>
					<el-button @click="showEditDialog(scope.row)" type="text" size="small" v-if="permission.btn_alarmRule_update">编辑</el-button>
					<el-button @click="deleteAlarmRule(scope.row)" type="text" size="small" v-if="permission.btn_alarmRule_delete">删除</el-button>
					<el-button type="text" size="small" @click="statusChange(scope.row)" v-if="permission.btn_alarmRule_switchStatus">{{ !scope.row.isEnabled? "启用" : "禁用" }}</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="page" v-if="tableData.length > 0">
			<div class="total_page"><span> 共{{tableTotalPage}}条 10条/页</span></div>
			<div style="margin-top:10px;text-align:right; margin-bottom:20px;" >
				<el-pagination background layout="prev, pager, next" :total="tableTotalPage" @current-change="pageChange" :current-page="tableCurrentPage"></el-pagination>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name:"alarmmgt",
		data:()=>{
			return {
				TmouserShow:null,
				W:false,
				fristLoad:false,
				addDialogVisible:false,
				editDialogVisible:false,
				viewDialogVisible:false,
				btnPressType: 0,//按钮类型： 0-默认 1-查询 2-重置 3-分页
				searchFormTemp: '',//临时搜索数据
				searchForm:{
					name:'',
					level:'',
					status: '',
				},
				sendTypeList:[],
				addForm:{
					name: "",
					remarks: "",
					alarmSendType: '',
					alarmLevel: 3,
					ruleType: 3,
					rules: [{ ruleKey: "", operator: "=", ruleValue: "", correlation: "" }],
					alarmNameRule:[ { required: true, message: '请输入告警名', trigger: 'blur' },
					],
				},
				editForm:{
					name: "",
					remarks: "",
					alarmSendType: '',
					alarmLevel: 3,
					ruleType: 3,
					rules: [{ ruleKey: "", operator: "=", ruleValue: "", correlation: "" }],
					alarmNameRule:[ { required: true, message: '请输入告警名', trigger: 'blur' },
					],
				},
				rules:{
					imei:[
						{ required: true, message: '请输入imei', trigger: 'blur' }
					],
				},
				viewForm:{
					rules:[],
					alarmSendTypeId:null,
					name:'',
					remarks:'',
					ruleType:null,
					alarmLevel:null,
				},
				tableData:[],
				status: new Map([[0,'待执行'],[1,'执行中'],[2,'已执行']]),
				level: new Map([[1,'高'],[2,'中'],[3,'低']]),
				ruleType: new Map([[1,'通信故障'],[2,'设备故障'],[3,'业务告警']]),
				currentRow:{},
				tableTotalPage:100,
				tableCurrentPage:1,
				permission:JSON.parse(localStorage.getItem("permission")),
			}
		},
		mounted:function(){
			this.initTable();
			this.getSentTypeSelect();
			let w  = document.documentElement.clientWidth || document.body.clientWidth;
				w>=1900?this.W = true:this.W = false
			window.onresize=()=>{
				let w  = document.documentElement.clientWidth || document.body.clientWidth;
				w>=1900?this.W = true:this.W = false
			}
		},
		computed:{
			span(){
				return this.W?5:7
			}
		},
		methods: {
			TmouseOver(ev) {
				console.log(ev)
				let offsetHeight = this.$refs.Tmover.offsetHeight
				let scrollHeight = this.$refs.Tmover.scrollHeight
				if(offsetHeight<scrollHeight){
					this.TmouserShow = ev
				}
				console.log(offsetHeight)
				console.log(scrollHeight)
			},
			Tonmouseout() {
				this.TmouserShow = null
			},
			getSentTypeSelect(){
				this.$RequestUtil.get({
					url: '/api/select/listSendType',
					type:'sync',
					params: {
					},
					success: (res) => {
						if(res.msg == this.$Global.RESPONSE.SUCCESS){
							this.sendTypeList = res.data;
						}else{
							this.$message.error(res.message||res.msg)
						}
						
					}
				});
			},

			search:function(){
				let temp;
				switch (this.btnPressType) {
					case 1:
						temp = commonUtils.cloneObj(this.searchForm);
						this.searchFormTemp = commonUtils.cloneObj(temp);
						break;
					case 0:
						temp ={
							status:'',
							imei:'',
						};
						break;
					case 2:
						temp = this.searchFormTemp
						break;
					case 3:
						temp = this.searchFormTemp;
						break;
				}
				this.$RequestUtil.get({
					url: '/api/alarmRule/listRules',
					type:'sync',
					params: {
						pageNum:this.tableCurrentPage,
						pageSize:10,
						name:temp.name,
						level:temp.level,
						status:temp.status,
					},
					success: (res) => {
						if(res.msg == this.$Global.RESPONSE.SUCCESS){
							this.tableData = res.data;
							this.tableTotalPage = res.totalPages;
							if(res.totalPages == 0&&this.fristLoad){
								this.$message.warning('查询不到符合条件的数据');
							}
							this.fristLoad = true
						}else{
							this.$message.error(res.message||res.msg)
						}
						
					}
				});
			},

			pageChange:function(targetPage){
				this.tableCurrentPage = targetPage;
				this.btnPressType = 3;
				this.search();
			},

			initTable:function(){
				this.search();
			},

			addDialogShow(){
				this.addForm.name = "";
				this.addForm.english = "";
				this.addForm.remarks = "";
				if(this.sendTypeList[0]){
					this.addForm.alarmSendType = this.sendTypeList[0].id;
				}
				this.addForm.alarmLevel = 3;
				this.addForm.ruleType = 3;
				this.addForm.rules = [
					{ ruleKey: "", operator: "=", ruleValue: "", correlation: "" }
				];
				this.addDialogVisible = true;
				setTimeout(()=>{
					this.$refs.focusinput.focus()
				},0)
			},
			
			btnSearch:function(){
				this.tableCurrentPage = 1;
				this.btnPressType = 1
				this.search();
			},

			clearSearch(){
				this.btnPressType = 2;
				this.searchForm ={
					name:'',
					level:'',
					status: '',
				}
			},

			addAlarmRule:function(){
				this.$refs['addForm'].validate((valid) => {
					if (valid) {
						this.$RequestUtil.post({
							url: '/api/alarmRule/addRule',
							type:'sync',
							params: {
								name:this.addForm.name,
								level:this.addForm.alarmLevel,
								ruleType:this.addForm.ruleType,
								alarmSendTypeId:this.addForm.alarmSendType,
								remarks:this.addForm.remarks,
								detailList: this.addForm.rules
							},
							success: (res) => {
								if(res.code == 0){
									this.$message({type:'success',message:'添加成功'})
									this.initTable();
									this.addDialogVisible = false;
								}else{
									this.$message({type: 'error',message: res.message||res.msg});
								}
							}
						});
					}else{
						this.$message({type: 'error',message: '请补充必填项!'});
					}
				});
			},

			showEditDialog:function(rowData){
				this.editForm.id = rowData.id;
				this.editForm.name = rowData.name;
				this.editForm.remarks = rowData.remarks;
				this.editForm.alarmSendType = rowData.alarmSendTypeId;
				this.editForm.alarmLevel = rowData.level;
				this.editForm.ruleType = rowData.ruleType;
				this.editForm.rules = rowData.alarmRuleDetails;
				this.editDialogVisible = true;
			},

			editAlarmRule:function(){
				this.$refs['editForm'].validate((valid) => {
					if (valid) {
						this.editForm.rules.forEach(e=>{e.alarmSendTypeId=''})
						this.$RequestUtil.post({
							url: '/api/alarmRule/updateRule',
							type:'sync',
							params: {
								id:this.editForm.id,
								name:this.editForm.name,
								level:this.editForm.alarmLevel,
								ruleType:this.editForm.ruleType,
								alarmSendTypeId:this.editForm.alarmSendType,
								remarks:this.editForm.remarks,
								detailList: this.editForm.rules
							},
							success: (res) => {
								if(res.code == 0){
									this.$message({
										type:'success',
										message:'编辑成功'
									})
									this.initTable();
									this.editDialogVisible = false;
								}else{
									this.$message({
										type: 'error',
										message: res.message||res.msg
									});
								}
							}
						});
					}else{
						this.$message({
							type: 'error',
							message: '请补充必填项!'
						});
					}
				});
			},

			deleteAlarmRule:function(rowData) {
				this.$confirm('此操作将删除该告警规则, 是否继续?', '提示', {
					cancelButtonClass: "btn-custom-cancel",
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$RequestUtil.get({
						url: '/api/alarmRule/deleteRule',
						type:'sync',
						params: {
							id:rowData.id
						},
						success: (res) => {
							if(res.code != -1){
								this.$message({
									type: 'success',
									message: '删除成功!'
								});
								this.initTable();
							}else {
								this.$message({
									type: 'error',
									message: res.message
								});
							}
						}
					});
				});
			},

			getDtuDetail(rowData){
				return new Promise((resolve,reject)=>{
					this.$RequestUtil.get({
					url: '/api/dtu/getDtuDetail',
					type:'sync',
					params: {
						id:rowData.id
					},
					success: (res) => {
						if(res.code != -1){
							resolve(res.data);
						}else {
							this.$message({
							type: 'error',
							message: res.message
							});
							reject(res)
						}
					}
					});
				})
			},

			viewDtu(rowData){
				this.currentRow = rowData;
				this.viewForm =commonUtils.cloneObj(rowData)
				this.viewForm.rules = this.viewForm.alarmRuleDetails
				this.viewForm.alarmLevel = this.level.get(rowData.level)
				this.viewForm.ruleType = this.ruleType.get(rowData.ruleType)
				if(rowData.alarmSendTypeId!=null){
					let sendType = this.sendTypeList.find(item=>item.id==rowData.alarmSendTypeId)
					if(sendType){
						this.viewForm.alarmSendTypeId = sendType.name
					}
				}
				this.viewDialogVisible = true;
			},

			parseDate:function(rowData){
				if(rowData.gmtCreate != null){
					let dateString = commonUtils.timestampToDate(rowData.gmtCreate,false);
					return dateString;
				}
			},

			//启用禁用
			statusChange(rowData) {
				this.$confirm(
					`是否确认${rowData.isEnabled ? "禁用" : "启用"}`,{
					cancelButtonClass: "btn-custom-cancel",
					}
					
				).then(() => {
					this.$RequestUtil.post({
						url: '/api/alarmRule/switchStatus',
						type:'sync',
						params: {
							id:rowData.id,
							isEnabled: !rowData.isEnabled
						},
						success: (res) => {
							if(res.code != -1){
								this.$message.success("操作成功");
								this.initTable();
							}else {
								this.$message({
								type: 'error',
								message: res.message
								});
							}
						}
					});
				});
			},

			/**规则明细相关 */
			addRuleLine(formName) {
				this[formName].rules.push({
					ruleKey: "",
					operator: "=",
					ruleValue: "",
					correlation: "and"
				});
			},

			delRuleLine(index,formName) {
				this[formName].rules.splice(index, 1);
			},
		}
	}
</script>
<style scoped>
	.delete{
		width: 18px;
		height: 19px;
		background-image:url('../../../static/img/del.png');
		cursor: pointer;
		background-repeat: no-repeat;
		position: relative;
		top: 6px;
		display: inline-block;
		left: 20px;
	}
	.delete:hover{
		background-image: url('../../../static/img/del-hover.png');
		background-repeat: no-repeat;
	}
	.table_searchbar{
		width:100%;
		margin-top: 10px;
		margin-bottom: 20px;
	}
	.table_searchbar .title11{
		color:  #606266;
		font-family: NotoSansHans-Regula;
		font-size: 14px;
	}
	.el-row {
		margin-bottom: 20px;
		&:last-child {
		margin-bottom: 0;
		}
	}
	.addForm .value{
		display: inline-block;
		width: 280px;
		text-align: center
	}
	.addForm .title{
		width: 70px;
		text-align: right;
		display:inline-block
	}
	.page{
		display: flex;
		justify-content: flex-end;
	}
	.total_page{
		margin-top: 20px;
		margin-right: 26px;
		color:#606266;
		font-size: 14px;
	}
	.form__input{
		width: 160px !important;
	}
	.form__textarea{
		width: 472px !important;
	}

	.form__input_small{
		width: 80px !important;
	}
	.dialog__list {
		max-height: 200px;
		overflow-y: auto;
	}
	.dialog__list /deep/ .el-scrollbar__wrap {
		overflow-x: hidden;
	}
</style>
<style >
	@media screen and (max-width: 1366px){
		#alarm-mgt .input-min-width .el-input {
			width: 80px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/alarm/alarmMgt.vue